import { parsePortalClientEnv } from '@disenchantment/config/portal-client';
import { createSupabaseAuthClient } from '@disenchantment/auth-client';

const env = parsePortalClientEnv(import.meta.env);

export const supabase = createSupabaseAuthClient(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY);
